import { tss } from 'tss-react';
import { useTheme } from '@mui/material/styles';

export default tss.create(() => {
  const theme = useTheme();
  return {
    root: {
      display: 'flex',
      lineHeight: '24px',
      marginBottom: theme.spacing(2),
      alignItems: 'center',
      '& pre': {
        margin: 0,
        marginRight: theme.spacing(1),
        flex: 1
      }
    }
  };
});
